import React from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  InnerLoader,
  submitAndReset,
  UiQuillAdapter,
} from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Field } from 'react-final-form';
import { composeValidators, required } from 'src/ui/validations';

export function ComplianceLogModal({ isActive, onCancel, onSubmit, action }) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Form
      onSubmit={onSubmit}
      render={({ form, hasValidationErrors, submitting, handleSubmit }) => {
        const submit = submitAndReset(handleSubmit, form);

        return (
          <form onSubmit={submit}>
            <Modal
              isActive={isModalVisible}
              className="add-background-assessment-log-modal"
            >
              <ModalBackground
                tag={FadeInDiv}
                pose={currentPose}
                onPoseComplete={onPoseComplete}
              />
              <ModalCard tag={AnimatedCard} pose={currentPose}>
                <InnerLoader visible={submitting} />
                <ModalCardHeader>
                  <ModalCardTitle
                    tag="h5"
                    className="has-text-weight-semibold columns is-vcentered"
                  >
                    <Column isSize="narrow" tag="span">
                      <span className="icon is-medium has-icon-gradient-bright">
                        <FontAwesomeIcon icon={['fal', 'plus']} size="lg" />
                      </span>
                    </Column>
                    <Column tag="span" hasTextColor="primary" isPaddingless>
                      {action}
                    </Column>
                  </ModalCardTitle>
                </ModalCardHeader>
                <ModalCardBody>
                  <Columns isMultiline>
                    <Column isSize="full">
                      <Field
                        component={UiQuillAdapter}
                        id="details"
                        name="details"
                        label="Comment"
                        required
                        validate={composeValidators('Comment', required)}
                      />
                    </Column>
                  </Columns>
                  <BulmaField isGrouped="centered">
                    <Control>
                      <Button
                        hasTextColor="info"
                        onClick={() => onCancel(form)}
                      >
                        Cancel
                      </Button>
                    </Control>
                    <Control>
                      <Button
                        isColor="gradient-bright"
                        type="submit"
                        disabled={submitting || hasValidationErrors}
                      >
                        {action}
                      </Button>
                    </Control>
                  </BulmaField>
                </ModalCardBody>
              </ModalCard>
            </Modal>
          </form>
        );
      }}
    />
  );
}

ComplianceLogModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  action: propTypes.string.isRequired,
};
